window.Vlitejs.registerProvider('youtube', window.VlitejsYoutube);
gsap.registerPlugin(DrawSVGPlugin);
gsap.registerPlugin(SplitText);
if (typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);
}
if (typeof Observer !== 'undefined') {
    gsap.registerPlugin(Observer);
}
if (typeof Draggable !== 'undefined') {
    gsap.registerPlugin(Draggable);
}
if (typeof InertiaPlugin !== 'undefined') {
    gsap.registerPlugin(InertiaPlugin);
}

// start: Inicializa las interacciones principales del menú superior.
function initMainNavInteractions() {
    btnMenu();
    openMenuSub();
}
// end: initMainNavInteractions

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMainNavInteractions);
} else {
    initMainNavInteractions();
}

document.addEventListener("DOMContentLoaded", function () {
    const tooltipTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.forEach(function (tooltipTriggerEl) {
        new bootstrap.Tooltip(tooltipTriggerEl);
    });
    initGlobalCursorFollower();
    keepBudgetModalOpenWhenAgendarOpens();
    if (document.querySelector('.swiper')) {
        checkAndInitializeSwiper();
    }
    initSwiperProyectos();
    initProyectoHoverVideos();
    initProyectoDestacadoCursor();
    initProyectoDestacadoCtaMotion();
    initProjectHeaderScroll();
    if (document.querySelectorAll(".counter_n").length) {
        window.counter(document.querySelectorAll('.counter_n'));
    }
    if (document.querySelector('.video-js')) {
        document.querySelectorAll('.video-js').forEach(video => {
            let provider = null;
            let poster = null;
            if (video.dataset.poster) {
                poster = video.dataset.poster
            }
            let options = {
                controls: true,
                volume: true,
                fullscreen: true,
                loop: false,
                muted: false,
                playPause: true,
                progressBar: true,
                time: true,
                bigPlay: true,
                poster: poster
            };

            if (video.dataset.youtubeId) {
                provider = "youtube";
            }
            let vliteConfig = {
                options: options,
            };

            if (provider) {
                vliteConfig.provider = provider;
            }
            const pVideo = new window.Vlitejs(video, vliteConfig)

            if (video instanceof HTMLVideoElement) {
                const bigPlayButton = pVideo?.player?.elements?.bigPlay || null;
                const setVideoCursorState = (cursorType) => {
                    video.dataset.cursor = cursorType;

                    if (bigPlayButton instanceof HTMLElement) {
                        bigPlayButton.dataset.cursor = cursorType;
                    }
                };

                setVideoCursorState('play');

                video.addEventListener('play', () => {
                    setVideoCursorState('pause');
                });

                video.addEventListener('pause', () => {
                    setVideoCursorState('play');
                });

                if (pVideo?.player?.on instanceof Function) {
                    pVideo.player.on('play', () => {
                        setVideoCursorState('pause');
                    });

                    pVideo.player.on('pause', () => {
                        setVideoCursorState('play');
                    });
                }

                video.addEventListener('click', (event) => {
                    if (!pVideo || !pVideo.player || !pVideo.player.controlBar) {
                        return;
                    }

                    pVideo.player.controlBar.togglePlayPause(event);
                });
            }

        })
    }

    if (window.scrollY !== 0) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(() => {
            scrollStickyCard(); 
        }, 200);
    } else {
        if( document.querySelector(".c-list-nav a")) {
            scrollStickyCard(); 
        }
    }
    if(document.querySelector('.c-swiper-dispositivos')) {
        swiperDispositivos(document.querySelectorAll('.c-swiper-dispositivos'));
    }
    setupVideoFullVideos();
});

let header;
let swiperResizeTimeout = null;

window.addEventListener('scroll', function () {
    resizeHeader()
    // navVentajas()
})
window.addEventListener("resize", () => {
    if (!document.querySelector('.swiper')) {
        return;
    }

    clearTimeout(swiperResizeTimeout);
    swiperResizeTimeout = setTimeout(() => {
        checkAndInitializeSwiper();
    }, 150);
})
// start: Devuelve la instancia de Collapse de Bootstrap si existe o la crea si aún no está inicializada.
function getCollapseInstance(element) {
    return bootstrap.Collapse.getInstance(element) || new bootstrap.Collapse(element, { toggle: false });
}
// end: getCollapseInstance

// start: Mantiene abierto el modal de presupuestador cuando se abre el modal de agendar desde dentro de él.
function keepBudgetModalOpenWhenAgendarOpens() {
    const budgetModalEl = document.getElementById('modalPresupuestador');
    const agendarModalEl = document.getElementById('modalAgendar');

    if (!budgetModalEl || !agendarModalEl) {
        return;
    }

    document.addEventListener('click', (event) => {
        const openFromBudgetBtn = event.target.closest('.js-open-agendar-from-presupuestador');
        if (!openFromBudgetBtn) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();

        if (!budgetModalEl.classList.contains('show')) {
            const agendarModal = bootstrap.Modal.getOrCreateInstance(agendarModalEl);
            agendarModal.show();
            return;
        }

        // Apertura manual: evita que Bootstrap cierre el modal activo.
        const agendarModal = bootstrap.Modal.getOrCreateInstance(agendarModalEl);
        agendarModal.show();

        // Conserva el estado de scroll-lock si ambos modales están abiertos.
        document.body.classList.add('modal-open');
    }, true);

    agendarModalEl.addEventListener('hidden.bs.modal', () => {
        if (budgetModalEl.classList.contains('show')) {
            document.body.classList.add('modal-open');
        }
    });

    budgetModalEl.addEventListener('hide.bs.modal', () => {
        document.activeElement?.blur();
    });
}
// end: keepBudgetModalOpenWhenAgendarOpens
//////////////// HEADER ESCONDER SCROLL START /////////////////////////
var scrollPos = 0;
const scrollThreshold = 100;

// start: Oculta o muestra la cabecera principal según la dirección del scroll y una distancia mínima recorrida.
function resizeHeader() {
    if (!header) return;
    // header.style.transition = "transform 0.5s ease";
    if (window.scrollY > scrollThreshold) {
        if ((document.body.getBoundingClientRect()).top > scrollPos) {
            gsap.to(header, {
                //xPercent: -50,
                yPercent: 0,
                duration: 0.25,
                // ease: "none"
            });
        } else {
            gsap.to(header, {
                //xPercent: -50,
                yPercent: -100,
                duration: 0.25,
                // ease: "none"
            });
            // header.style.transform = 'translate(-50%, -100%)'
            // header.style.transition = "transform 0.5s ease";
        } 
    }  else {
        gsap.to(header, {
            yPercent: 0,
            duration: 0.35,
            ease: "none"
        });
    }
    scrollPos = (document.body.getBoundingClientRect()).top;
}
// end: resizeHeader
//////////////// HEADER ESCONDER SCROLL END /////////////////////////

//////////////// SWIPER NORMALES START /////////////////////////
// Almacena las instancias de Swiper en un array para gestionar múltiples sliders
let cSwipers = [];
let observers = []; 

// start: Recupera el slide inicial guardado en el DOM para reinstanciar un swiper sin perder posición.
function getStoredSwiperSlide(swiper) {
    const storedSlide = Number.parseInt(swiper.dataset.swiperInitialSlide || '', 10);
    return Number.isNaN(storedSlide) ? null : storedSlide;
}
// end: getStoredSwiperSlide

// start: Guarda el índice activo actual de un swiper en el dataset del propio contenedor.
function storeSwiperSlide(swiperInstance) {
    if (!swiperInstance || !swiperInstance.el) {
        return;
    }

    const currentSlide = swiperInstance.params.loop
        ? swiperInstance.realIndex
        : swiperInstance.activeIndex;

    swiperInstance.el.dataset.swiperInitialSlide = String(Math.max(currentSlide, 0));
}
// end: storeSwiperSlide

// start: Recorre los sliders estándar de la página y los inicializa según sus plugins y breakpoint.
function initializeSwiper() {
    const excludedSwipers = ['.c-swiper-proyectos', '.swiper-agendar'];

    document.querySelectorAll('.swiper').forEach((swiper) => {
        if (excludedSwipers.some(selector => swiper.matches(selector))) {
            return;
        }

        const plugins = swiper.dataset.plugins || '';

        if (plugins && !plugins.includes('animation')) {
            let swiperConfig = {
                slidesPerView: "auto",
                spaceBetween: 32,
            };
            const initialSlide = getStoredSwiperSlide(swiper);
            
            if (window.matchMedia('(max-width: 740px)').matches) {
                swiperConfig.spaceBetween = 20;
            }

            if (initialSlide !== null) {
                swiperConfig.initialSlide = initialSlide;
            }
            
            // Configura plugins adicionales según el dataset
            if (plugins) {
                if (plugins.includes('pagination')) {
                    const paginationEl = swiper.querySelector('.swiper-pagination');

                    swiperConfig.pagination = {
                        el: paginationEl,
                    };
                }
                if (plugins.includes('navigation')) {
                    swiperConfig.navigation = {
                        nextEl: swiper.querySelector('.swiper-button-next'),
                        prevEl: swiper.querySelector('.swiper-button-prev'),
                    };
                }
                if (plugins.includes('autoplay')) {
                    swiperConfig.autoplay = {
                        delay: -1,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: false,
                    };
                    swiperConfig.loop = true;
                    swiperConfig.freeMode = true;
                    swiperConfig.grabCursor = true;
                    swiperConfig.speed = 5000;
                }
                if (plugins.includes('scroll')) {
                    swiperConfig.mousewheel = {
                        releaseOnEdges: true,
                    };
                }

                let swiperInstance = null;

                if (plugins.includes('tablet')) {
                    if (window.matchMedia('(max-width: 992px)').matches) {
                        swiperInstance = new Swiper(swiper, swiperConfig);
                    }
                } else {
                    swiperInstance = new Swiper(swiper, swiperConfig);
                }

                if (!swiperInstance) {
                    return;
                }

                delete swiper.dataset.swiperInitialSlide;
                cSwipers.push(swiperInstance);

            }
        }
    });
}
// end: initializeSwiper

// Función para destruir todas las instancias de Swiper
// start: Destruye todas las instancias de swiper almacenadas y limpia observers asociados.
function destroySwiper() {
    cSwipers.forEach((swiperInstance) => {
        if (swiperInstance) {
            storeSwiperSlide(swiperInstance);
            swiperInstance.destroy(true, true);
        }
    });
    cSwipers = []; // Vacía el array de instancias
    observers.forEach((observer) => observer.disconnect());
    observers = []; // Limpia el array de observers
}
// end: destroySwiper

// Verifica el tamaño de la pantalla e inicializa/destruye Swiper
// start: Reinicia el sistema de swipers para adaptarlo al tamaño actual de pantalla.
function checkAndInitializeSwiper() {
    destroySwiper();
    initializeSwiper();
}
// end: checkAndInitializeSwiper

//////////////// LOGOS MARQUEE START /////////////////////////
const LOGOS_MARQUEE_PIXELS_PER_SECOND = 48;
let logosMarqueeResizeObserver = null;
let logosMarqueeResizeRaf = null;

function syncLogosMarquees() {
    document.querySelectorAll('.c-swiper-logos_track').forEach((track) => {
        const viewport = track.closest('.c-swiper-logos_viewport');
        const baseGroup = track.querySelector('.c-swiper-logos_group:not([data-marquee-clone])');

        if (!viewport || !baseGroup) {
            return;
        }

        track.querySelectorAll('[data-marquee-clone]').forEach((clone) => clone.remove());

        const distance = baseGroup.getBoundingClientRect().width;

        if (!distance) {
            return;
        }

        // Hay que cubrir el viewport y dejar otro grupo completo entrando por la derecha.
        const groupCount = Math.max(2, Math.ceil(viewport.getBoundingClientRect().width / distance) + 1);

        for (let copy = 1; copy < groupCount; copy += 1) {
            const clone = baseGroup.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('data-marquee-clone', '');
            track.appendChild(clone);
        }

        const duration = Math.max(distance / LOGOS_MARQUEE_PIXELS_PER_SECOND, 12);
        track.style.setProperty('--logos-marquee-distance', `-${distance}px`);
        track.style.animationDuration = `${duration.toFixed(2)}s`;
    });
}

function queueLogosMarqueeSpeedSync() {
    if (logosMarqueeResizeRaf) {
        cancelAnimationFrame(logosMarqueeResizeRaf);
    }

    logosMarqueeResizeRaf = requestAnimationFrame(() => {
        logosMarqueeResizeRaf = null;
        syncLogosMarquees();
    });
}

function initLogosMarqueeSpeed() {
    const tracks = document.querySelectorAll('.c-swiper-logos_track');

    if (!tracks.length) {
        return;
    }

    queueLogosMarqueeSpeedSync();

    window.addEventListener('load', queueLogosMarqueeSpeedSync, { once: true });
    window.addEventListener('resize', queueLogosMarqueeSpeedSync, { passive: true });

    if (typeof ResizeObserver === 'undefined' || logosMarqueeResizeObserver) {
        return;
    }

    logosMarqueeResizeObserver = new ResizeObserver(() => {
        queueLogosMarqueeSpeedSync();
    });

    tracks.forEach((track) => {
        const viewport = track.closest('.c-swiper-logos_viewport');
        const baseGroup = track.querySelector('.c-swiper-logos_group:not([data-marquee-clone])');

        if (viewport) {
            logosMarqueeResizeObserver.observe(viewport);
        }

        if (baseGroup) {
            logosMarqueeResizeObserver.observe(baseGroup);
        }
    });
}

document.addEventListener('DOMContentLoaded', initLogosMarqueeSpeed);
//////////////// LOGOS MARQUEE END /////////////////////////

//////////////// SWIPER NORMALES END /////////////////////////

//////////////// SWIPER CASO START /////////////////////////
if(document.querySelector('.c-swiper-caso')) {
    let autoplayInterval;
    
    const swiperConfig = {
        spaceBetween: 30,
        effect: "fade",
        loop: true,
        on: {
            init() {
                setTimeout(() => startAnimation(this), 700);
                initializeSlideEvents(this);
                startManualAutoplay(this);
                updateProgressBar(this);
            },
            slideChangeTransitionEnd() {
                initializeSlideEvents(this);
                startAnimation(this);
                updateProgressBar(this, true);
            },
        },
    };
    
    let swiper2 = new Swiper(document.querySelector('.c-swiper-caso'), swiperConfig);
    function updateProgressBar(swiper, isSlideChange) {
        const progressBar = swiper.slides[swiper.activeIndex].querySelector('.c-swiper-caso_progress-bar');
        const duration = isSlideChange ? 7.5 : 8.5;
        progressBar.style.width = 0
        if (progressBar) {
            gsap.to(progressBar, {
                width: "100%",
                duration: duration,
                ease: "linear",
                delay: 1.5
            });
        }
    }
    
    function startManualAutoplay(swiper) {
        autoplayInterval = setInterval(() => animationSlider(swiper), 10000);
        // autoplayInterval = setInterval(() => animationSlider(swiper), 100000);
    }
    
    function stopManualAutoplay() {
        clearInterval(autoplayInterval);
    }
    
    function initializeSlideEvents(swiper) {
        const nextButton = swiper.slides[swiper.activeIndex].querySelector('.c-swiper-caso_next');
        if (nextButton) {
            nextButton.addEventListener('click', () => {
                animationSlider(swiper);
                stopManualAutoplay();
                startManualAutoplay(swiper);
            });
        }
    }
    
    function animationSlider(swiper) {
        const slide = swiper.slides[swiper.activeIndex];
        const curtains = slide.querySelectorAll('.curtain');
        const info = slide.querySelectorAll('.c-swiper-caso_animation');
    
        curtains.forEach(curtain => {
            gsap.set(curtain, { clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)", xPercent: 100 });
            gsap.to(curtain, {
                duration: 0.8,
                ease: "sine.inOut",
                xPercent: 0,
            });
        });
    
        gsap.to(info, {
            duration: 0.8,
            ease: "sine.inOut",
            x: -35,
            opacity: 0,
        });
    
        gsap.to(slide.querySelector('.c-swiper-caso_progress'), {
            duration: 0.8,
            ease: "sine.inOut",
            opacity: 0,
        });
    
        gsap.to(slide.querySelector('.c-swiper-caso_next .txt'), {
            duration: 0.8,
            ease: "sine.inOut",
            x: 28,
            opacity: 0,
            onComplete: () => swiper.slideNext(),
        });
    }
    
    function startAnimation(swiper) {
        const slide = swiper.slides[swiper.activeIndex];
        const curtains = slide.querySelectorAll('.curtain');
        const info = slide.querySelectorAll('.c-swiper-caso_animation');
    
        curtains.forEach(curtain => {
            gsap.to(curtain, {
                duration: 0.8,
                ease: "sine.inOut",
                clipPath: "polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)",
                delay: 0.3,
            });
        });
    
        gsap.to(info, {
            duration: 0.8,
            ease: "sine.inOut",
            x: 0,
            opacity: 1
        });
    
        gsap.to(slide.querySelector('.cont-txt'), {
            duration: 1.5,
            ease: "power1.inOut",
            opacity: 1,
        });
    
        gsap.to(slide.querySelector('.c-swiper-caso_progress'), {
            duration: 0.8,
            ease: "sine.inOut",
            opacity: 1,
        });
    
        gsap.to(slide.querySelector('.c-swiper-caso_next .txt'), {
            duration: 0.8,
            ease: "sine.inOut",
            x: 0,
            opacity: 1,
        });
    
        gsap.to(slide.querySelector('.c-swiper-caso_next .ani'), {
            duration: 1.5,
            ease: "power1.inOut",
            opacity: 1,
        });
    }
}
//////////////// SWIPER CASO END /////////////////////////

//////////////// STICKY CARD ANIMACION SCROLL START /////////////////////////
// start: Dibuja y anima el progreso del listado sticky de navegación en función del scroll entre secciones.
function scrollStickyCard() {
        const anchors = document.querySelectorAll(".c-list-nav a");
        
        
        anchors.forEach((anchor, index) => {
            const targetId = anchor.getAttribute('href');  
            const targetSection = document.querySelector(targetId);  
            const nextTargetSection = anchors[index + 1] ? document.querySelector(anchors[index + 1].getAttribute('href')) : null;
            const circle = anchor.querySelector('#circle');  
            const chevron = anchor.querySelector('.chevron');  
            if (circle && targetSection) {
                gsap.set(circle, {
                  drawSVG: '0%',   
                });
                const scrollTriggerConfig = nextTargetSection
                    ? {
                        trigger: targetSection,
                        start: "-200% 60%",
                        endTrigger: nextTargetSection,
                        end: "top 60%", 
                        scrub: true,
                        // markers: true
                        }
                    : {
                        trigger: targetSection,
                        start: "-40% 60%",
                        end: `${anchor.closest('.container').scrollHeight - targetSection.offsetTop}px`, // Extiende hasta el final de la página
                        scrub: true,
                        // markers: true
                        };
            
            
                gsap.to(circle, {
                  drawSVG:'0% 100%',  
                  scrollTrigger: scrollTriggerConfig,
                  ease: Power1.easeInOut 
                });
                gsap.to(chevron, {
                 color: '#fff',
                //  color: 'black',
                 scrollTrigger: scrollTriggerConfig,
                  ease: Power1.easeInOut 
                });
              }
          });
}
// end: scrollStickyCard
//////////////// STICKY CARD ANIMACION SCROLL END /////////////////////////

////////////////  ABRIR MODAL BOTON FLOTANTE START /////////////////////////
if(document.querySelector('.c-video-flotante_btn')) {

    const modalTimeline = gsap.timeline({ paused: true, reversed: true });
    const vMod = document.querySelector('.c-video-flotante_modal .videojs');

    let vModprovider = null;
    let vModoptions = {
        controls: true,
        volume: true,
        fullscreen: true,
        loop: false,
        muted: false,
        playPause: true,
        progressBar: true,
        time: true,
        bigPlay: false,
    };

    if (vMod.dataset.youtubeId) {
        vModprovider = "youtube";
    }
    let vModConfig = {
        options: vModoptions,
    };

    if (vModprovider) {
        vModConfig.provider = vModprovider;
    }

    const vModal = new window.Vlitejs(vMod, vModConfig);
    modalTimeline.to('.c-video-flotante_modal', {
        duration: .8,
        width: "calc(100dvw - 1rem)", 
        height: "calc(100dvh - 1rem)", 
        mOrigin: "bottom right",
        ease: "power2.inOut"
    });

    modalTimeline.fromTo('.c-video-flotante_modal .cont-video', 
        { autoAlpha: 0 }, 
        { 
            duration: 0.5,
            autoAlpha: 1,
            ease: "power2.inOut"
        },
        0.4
    );
   
    modalTimeline.fromTo('.c-video-flotante_modal', 
        { borderRadius: '3.5rem' }, 
        { 
            duration: 0.5,
            borderRadius: '2rem',
            ease: "power2.inOut"
        },
        0.4
    );
   
   
    document.querySelector('.c-video-flotante_btn').addEventListener('click', ()=> {
        player = document.querySelector('.c-video-flotante_modal iframe');
        video = document.querySelector('.c-video-flotante_modal video');
        if (modalTimeline.reversed()) {
            modalTimeline.play();
            if (player != null){ player.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');}
            if (video != null){ video.play();}
        } else {
            modalTimeline.reverse();
            if (player != null){player.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');}
            if (video != null){ video.pause();}

        } 
       document.body.classList.toggle('no-scroll')
       document.querySelector('.c-video-flotante_btn').classList.toggle('zIndex')
       document.querySelector('.c-video-flotante_modal').classList.toggle('zIndex')
    })
}
////////////////  ABRIR MODAL BOTON FLOTANTE END /////////////////////////

// start: Busca el siguiente bloque renderizado real saltando scripts para localizar el contenido que sigue a un bloque dado.
function getNextRenderedBlock(element) {
    let currentElement = element;

    while (currentElement && currentElement !== document.body) {
        let nextElement = currentElement.nextElementSibling;

        while (nextElement && nextElement.tagName === 'SCRIPT') {
            nextElement = nextElement.nextElementSibling;
        }

        if (nextElement) {
            return nextElement;
        }

        currentElement = currentElement.parentElement;
    }

    return null;
}
// end: getNextRenderedBlock

// start: Marca el bloque siguiente a cada cabecera de proyecto para aplicarle el estilo de salida del header pinned.
function initProjectHeaderScroll() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        return;
    }

    const headers = document.querySelectorAll('.c-header-project');
    if (!headers.length) {
        return;
    }

    headers.forEach((headerSection) => {
        if (headerSection.dataset.projectHeaderScrollReady === 'true') {
            return;
        }

        const image = headerSection.querySelector('.c-header-project_img');
        const nextRenderedBlock = getNextRenderedBlock(headerSection);
        const info = nextRenderedBlock && nextRenderedBlock.classList.contains('c-header-project_info')
            ? nextRenderedBlock
            : null;

        if (!image) {
            return;
        }

        headerSection.dataset.projectHeaderScrollReady = 'true';

        if (info) {
            info.classList.add('is-after-pinned-project-header');
        }
    });
}
// end: initProjectHeaderScroll

// start: Divide títulos en caracteres y anima su aparición con GSAP al entrar en viewport.
function initAnimationTitle() {
    if (
        typeof gsap === 'undefined' ||
        typeof ScrollTrigger === 'undefined' ||
        typeof SplitText === 'undefined'
    ) {
        return;
    }

    const titleSelector = 'h1:not(.no-animation), h2:not(.no-animation), h3:not(.no-animation), h4:not(.no-animation), h5:not(.no-animation), h6:not(.no-animation), .h1:not(.no-animation), .h2:not(.no-animation), .h3:not(.no-animation), .h4:not(.no-animation), .h5:not(.no-animation), .h6:not(.no-animation)';
    const blocks = document.querySelectorAll('.animation-title');

    if (!blocks.length) {
        return;
    }

    blocks.forEach((block) => {
        const titles = Array.from(block.querySelectorAll(titleSelector))
            .filter((title) => title.textContent.trim() !== '' && title.dataset.animationTitleReady !== 'true');

        titles.forEach((title) => {
            const splitTitle = new SplitText(title, {
                type: 'words,chars',
                wordsClass: 'animation-title-word',
                charsClass: 'animation-title-char'
            });

            if (!splitTitle.chars.length) {
                return;
            }

            title.dataset.animationTitleReady = 'true';

            if (splitTitle.words.length) {
                gsap.set(splitTitle.words, {
                    display: 'inline-block',
                    whiteSpace: 'nowrap'
                });
            }

            gsap.set(splitTitle.chars, {
                opacity: 0.01
            });

            gsap.to(splitTitle.chars, {
                opacity: 1,
                duration: .25,
                ease: 'none',
                stagger: {
                    amount: 1,
                    from: 'start'
                },
                scrollTrigger: {
                    trigger: title,
                    start: 'top 80%',
                    end: 'bottom 55%',
                    scrub: true,
                    markers:false
                }
            });
        });
    });
}
// end: initAnimationTitle

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnimationTitle);
} else {
    initAnimationTitle();
}

////////////////  ANIAMCION HEADER HOME START /////////////////////////
if (
    document.querySelector('.c-header') &&
    typeof gsap !== 'undefined' &&
    typeof SplitText !== 'undefined'
) {
    const headerSection = document.querySelector('.c-header');
    const imagenes = Array.from(headerSection.querySelectorAll('.lottie-file'));

    const rotatingItems = Array.from(headerSection.querySelectorAll('.rotating-text_item'))
        .filter((item) => item.textContent.trim() !== '');

    if (rotatingItems.length) {
        const splitRotatingItems = rotatingItems.map((item) => {
            const split = new SplitText(item, { type: 'words,chars' });
            gsap.set(split.words, { display: 'inline-block', whiteSpace: 'nowrap' });
            return split;
        });

        const setActiveRotatingItem = (activeIndex) => {
            rotatingItems.forEach((item, index) => {
                const isActive = index === activeIndex;

                item.classList.toggle('is-active', isActive);
                gsap.set(item, { autoAlpha: isActive ? 1 : 0 });
            });
        };

        const setActiveImage = (activeIndex) => {
            if (!imagenes.length) {
                return;
            }

            const imageIndex = activeIndex % imagenes.length;

            imagenes.forEach((image, index) => {
                gsap.set(image, {
                    scale: index === imageIndex ? 1 : 0.75,
                    autoAlpha: index === imageIndex ? 1 : 0
                });
            });
        };

        setActiveRotatingItem(0);
        setActiveImage(0);

        if (splitRotatingItems.length === 1) {
            gsap.from(splitRotatingItems[0].chars, {
                opacity: 0,
                x: -10,
                duration: 0.6,  // ⏱️ duración de cada letra
                stagger: 0.06,  // ⏱️ retardo entre letras
                ease: 'power2.out'
            });
        } else {
            const tl = gsap.timeline({ repeat: -1, delay: 0.5 });

            splitRotatingItems.forEach((splitItem, index) => {
                const nextIndex = (index + 1) % splitRotatingItems.length;
                const currentImage = imagenes[index % imagenes.length];
                const nextImage = imagenes[nextIndex % imagenes.length];

                tl.add(() => {
                    setActiveRotatingItem(index);
                })
                .from(splitItem.chars, {
                    opacity: 0,
                    x: -10,
                    duration: 0.2,  // ⏱️ duración de cada letra
                    stagger: 0.06,  // ⏱️ retardo entre letras
                    ease: 'power2.out'
                })
                .to(splitItem.chars, {
                    opacity: 0,
                    x: -10,
                    duration: 0.5,
                    ease: 'power2.in',
                    delay: 4
                })
                .add(() => {
                    rotatingItems[index].classList.remove('is-active');
                    gsap.set(rotatingItems[index], { autoAlpha: 0 });
                });

                if (imagenes.length >= 2 && currentImage !== nextImage) {
                    tl.to(currentImage, {
                        scale: 0.75,
                        autoAlpha: 0,
                        duration: 1,
                        ease: 'power2.in'
                    }, '-=0.75')
                    .to(nextImage, {
                        scale: 1,
                        autoAlpha: 1,
                        duration: 1,
                        ease: 'power2.out'
                    }, '-=0.75');
                }
            });
        }

    }
}
////////////////  ANIAMCION HEADER HOME END /////////////////////////

// start: Crea un cursor follower global con inercia, oculta el cursor nativo en desktop y cambia icono/tema según el contexto.
function initGlobalCursorFollower() {
    if (document.body.dataset.cursorFollower === 'true') {
        return;
    }

    const hoverQuery = window.matchMedia('(hover: hover)');
    const finePointerQuery = window.matchMedia('(pointer: fine)');
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!hoverQuery.matches || !finePointerQuery.matches || reducedMotionQuery.matches) {
        const handleToDesktop = () => {
            if (hoverQuery.matches && finePointerQuery.matches && !reducedMotionQuery.matches) {
                hoverQuery.removeEventListener('change', handleToDesktop);
                finePointerQuery.removeEventListener('change', handleToDesktop);
                initGlobalCursorFollower();
            }
        };
        hoverQuery.addEventListener('change', handleToDesktop);
        finePointerQuery.addEventListener('change', handleToDesktop);
        return;
    }

    document.body.dataset.cursorFollower = 'true';
    document.documentElement.classList.add('has-cursor-follower');

    const follower = document.createElement('span');
    follower.className = 'o-cursor-follower';
    follower.setAttribute('aria-hidden', 'true');
    follower.innerHTML = `
        <span class="o-cursor-follower_content">
            <svg class="o-cursor-follower_icon link" viewBox="0 0 512 512" focusable="false" aria-hidden="true">
                <path d="M84.9,210.2c.7,2.7-.9,5.4-3.5,6.1l-48.3,12.9c-.4.1-.9.2-1.3.2-2.2,0-4.2-1.5-4.8-3.7-.7-2.7.9-5.4,3.5-6.1l48.3-12.9c2.7-.7,5.4.9,6.1,3.5ZM213.5,81.6c.4.1.9.2,1.3.2,2.2,0,4.2-1.5,4.8-3.7l12.9-48.3c.7-2.7-.9-5.4-3.5-6.1-2.7-.7-5.4.9-6.1,3.5l-12.9,48.3c-.7,2.7.9,5.4,3.5,6.1ZM292.5,159.6c.4,0,.9,0,1.3-.2l48.3-12.9c2.7-.7,4.2-3.5,3.5-6.1-.7-2.7-3.5-4.2-6.1-3.5l-48.3,12.9c-2.7.7-4.2,3.5-3.5,6.1.6,2.2,2.6,3.7,4.8,3.7ZM479,443l-39.1,39.1c-4.1,4.1-9.5,6.3-15.3,6.3s-11.2-2.2-15.3-6.3l-78.7-78.6-39.5,39.5c-5.2,5.3-13,7.5-20.2,5.8-7.4-1.7-13.2-7.1-15.5-14.2l-74.4-223.1c-2.6-7.8-.6-16.3,5.2-22.1,5.8-5.8,14.3-7.8,22.1-5.2l221.2,73.7c4,.9,7.6,2.9,10.5,5.8,4.1,4.1,6.3,9.5,6.3,15.3s-2.2,11.2-6.3,15.3c0,0,0,0,0,0,0,0,0,0,0,0l-39.5,39.5,78.7,78.7h0c8.4,8.4,8.4,22.1,0,30.5h0ZM471.9,419.6l-82.2-82.2c-.9-.9-1.5-2.2-1.5-3.5s.5-2.6,1.5-3.5l43.1-43h0c0,0,0,0,0,0,4.5-4.5,4.5-11.9,0-16.4-1.6-1.6-6.1-3.2-6.3-3.3l-221.4-73.8c-4.2-1.4-8.7-.3-11.9,2.8-3.1,3.1-4.2,7.7-2.8,11.9l74.4,223.1c1.3,3.8,4.4,6.7,8.3,7.6,3.9.9,8-.3,10.9-3.1l43.1-43.1c1-1,2.3-1.5,3.5-1.5s2.6.5,3.5,1.5l82.2,82.2c2.2,2.2,5.1,3.4,8.2,3.4s6-1.2,8.2-3.4l39.1-39.1c4.5-4.5,4.5-11.9,0-16.4h0ZM76.7,66.4c-2-2-5.1-2-7.1,0-2,2-2,5.1,0,7.1l35.4,35.4c1,1,2.3,1.5,3.5,1.5s2.6-.5,3.5-1.5c2-2,2-5.1,0-7.1l-35.4-35.4ZM159.1,284.5c-2.7-.7-5.4.9-6.1,3.5l-12.9,48.3c-.7,2.7.9,5.4,3.5,6.1.4.1.9.2,1.3.2,2.2,0,4.2-1.5,4.8-3.7l12.9-48.3c.7-2.7-.9-5.4-3.5-6.1Z"/>
            </svg>
           <svg class="o-cursor-follower_icon play" viewBox="0 0 250.6 271.9" focusable="false" aria-hidden="true">
                <path fill="currentColor" d="M30.6.5c10.9-1.5,17.8.7,27.2,5.4,59,29.7,116,68.4,175,98.8,23,14.1,24,45.9,1.8,61.5l-176.3,99.7c-23.8,14.9-55.5.8-58.3-27.5V32.2C1.7,17.1,15.4,2.5,30.6.5ZM34.3,16.2c-10.4,1.4-17.4,9.4-18.6,19.7v199.5c.8,8.5,5,15.8,13.3,18.9s14.7.9,23.2-3.5c58.4-29.8,114.8-67.3,173-97.8,12.6-9.2,12.6-25,0-34.2C167,88.4,110.6,51,52.3,21.1c-6.3-3.2-10.4-5.9-17.9-4.9Z"/>
            </svg>
            <svg class="o-cursor-follower_icon pause" viewBox="0 0 270.9 305.4" focusable="false" aria-hidden="true">
                <path fill="currentColor" d="M38,1c31.4-2.7,68.6-2.3,73.5,36.8v230.4c-5.4,38.2-41.1,38.6-72.2,36.4S3.1,290,0,269.1V35.7C3.4,15.6,17.9,2.7,38,1ZM35,17.4c-9.9,1.4-18.4,11.3-19.3,21.1v229c1.6,10.8,10.3,19.7,21.3,20.7s30.2,1,38.9,0,19.4-12.6,19.9-23.5V40.1c-.9-11.5-9.4-21.9-21.3-23s-31-1-39.5.2Z"/>
                <path fill="currentColor" d="M197.5,1c30.7-2.6,67.7-2.6,73.5,35.3v233.4c-3.6,20.6-18.6,33.4-39.3,34.9-31.3,2.2-67.3,1.7-72.2-37.1V37.2c2.5-20.5,17.6-34.4,38-36.2ZM194.4,17.4c-10.5,1.6-18.6,12.3-19.3,22.7v225.2c.8,11.5,9.5,21.9,21.3,23,9.2.8,29.9,1,38.9-.1s19-11.2,19.9-21.3V37.9c-1.6-10.8-10.3-19.7-21.3-20.7-8.7-.8-31.3-1.1-39.5.2Z"/>
            </svg>
            <svg class=" o-cursor-follower_icon scroll" viewBox="0 0 281.3 510.7" focusable="false" aria-hidden="true">
                <rect x="10.7" y="10.7" width="260" height="489.4" rx="130" ry="130" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="21.3"/>
                <rect id="animation" x="125.7" y="73.3" width="30" height="66.8" rx="15" ry="15" fill="currentColor"/>
            </svg>
            <svg class="o-cursor-follower_icon drag" viewBox="0 0 13.8 15.3" focusable="false" aria-hidden="true">
                <path d="M3.8,1.6c.2-2.1,3.4-2.1,3.7,0v3.7c1.2.2,2.4.3,3.6.6,2.4.6,3.2,2.4,2.6,4.7s-1.3,4.6-4,4.8-2.3,0-3.2,0c-1.4,0-2-.6-2.9-1.6s-2.1-2.4-2.9-3.6-.4-.5-.5-.8c-.5-1.5.9-2.9,2.4-2.4s.8.5,1.2.8,0,0,.1,0V1.6ZM5.5,1.1c-.3,0-.6.3-.7.6v7.4c0,.4-.4.7-.8.5s-.3-.2-.4-.3c-.4-.4-.9-.9-1.4-1.2s-.8-.3-1.1.1,0,.9.3,1.3c.9,1.1,1.9,2.4,2.8,3.5s1,1.1,2,1.1,2.3,0,3.2,0c1.9-.1,2.3-2,2.7-3.4s.6-2.5-.7-3.4-3.5-.7-4.8-1-.5-.3-.6-.6c-.1-1.3,0-2.7,0-4,0-.4-.4-.6-.8-.6Z"/>
            </svg>
        </span>
    `;
    document.body.appendChild(follower);

    const interactiveSelector = [
        'a[href]',
        'button:not([disabled])',
        '.btn',
        '[role="button"]',
        'summary',
        'label[for]',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        'input[type="submit"]:not([disabled])',
        'input[type="button"]:not([disabled])',
        '[data-bs-toggle]',
        '.link-absolute',
        '[data-cursor]',
        '[tabindex]:not([tabindex="-1"])'
    ].join(',');

    const cursorTypeIcons = {
        link: true,
        play: true,
        pause: true,
        scroll: true,
        drag: true
    };
    const idleScale = 0.36;
    const hoverScale = 1.18;
    const pressedScale = 1.02;
    const pressedIdleScale = 0.3;

    let targetX = window.innerWidth * 0.5;
    let targetY = window.innerHeight * 0.5;
    let currentX = targetX;
    let currentY = targetY;
    let targetScale = idleScale;
    let currentScale = idleScale;
    let isVisible = false;
    let isGrow = false;
    let isPressed = false;
    let frameId = null;
    let currentTheme = '';
    let currentCursorType = '';

    const themeValues = {
        light: {
            fill: 'rgba(19, 33, 53, 0.38)',
            glow: 'rgba(19, 33, 53, 0.08)',
            foreground: '#ffffff',
            stroke: 'rgba(19, 33, 53, 0.12)'
        },
        dark: {
            fill: 'rgba(255, 255, 255, 0.42)',
            glow: 'rgba(255, 255, 255, 0.1)',
            foreground: '#031f27',
            stroke: 'rgba(3, 31, 39, 0.1)'
        }
    };

    const parseColor = (value) => {
        if (!value || value === 'transparent') {
            return null;
        }

        const match = value.match(/rgba?\(([^)]+)\)/i);
        if (!match) {
            return null;
        }

        const parts = match[1].split(',').map((part) => Number.parseFloat(part.trim()));
        if (parts.length < 3 || parts.some((part, index) => index < 3 && Number.isNaN(part))) {
            return null;
        }

        return {
            r: parts[0],
            g: parts[1],
            b: parts[2],
            a: Number.isNaN(parts[3]) ? 1 : parts[3]
        };
    };

    const getRelativeLuminance = ({ r, g, b }) => {
        const normalize = (channel) => {
            const value = channel / 255;
            return value <= 0.03928 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
        };

        const red = normalize(r);
        const green = normalize(g);
        const blue = normalize(b);

        return 0.2126 * red + 0.7152 * green + 0.0722 * blue;
    };

    const getThemeFromElement = (element) => {
        if (!(element instanceof Element)) {
            return 'light';
        }

        const explicitThemeHost = element.closest('[data-cursor-theme]');
        if (explicitThemeHost) {
            const explicitTheme = explicitThemeHost.getAttribute('data-cursor-theme');
            if (explicitTheme === 'light' || explicitTheme === 'dark') {
                return explicitTheme;
            }
        }

        let currentElement = element;

        while (currentElement && currentElement !== document.documentElement) {
            const styles = window.getComputedStyle(currentElement);
            const backgroundColor = parseColor(styles.backgroundColor);

            if (backgroundColor && backgroundColor.a > 0) {
                return getRelativeLuminance(backgroundColor) > 0.58 ? 'light' : 'dark';
            }

            currentElement = currentElement.parentElement;
        }

        const bodyColor = parseColor(window.getComputedStyle(document.body).backgroundColor);
        if (!bodyColor) {
            return 'light';
        }

        return getRelativeLuminance(bodyColor) > 0.58 ? 'light' : 'dark';
    };

    const syncTheme = (element) => {
        const interactiveButton = element instanceof Element ? element.closest('.btn-primary') : null;

        if (interactiveButton) {
            currentTheme = 'dark';
            follower.style.setProperty('--cursor-fill', themeValues.dark.fill);
            follower.style.setProperty('--cursor-glow', themeValues.dark.glow);
            follower.style.setProperty('--cursor-foreground', themeValues.dark.foreground);
            follower.style.setProperty('--cursor-stroke', themeValues.dark.stroke);
            return;
        }

        const nextTheme = getThemeFromElement(element);

        if (nextTheme === currentTheme) {
            return;
        }

        currentTheme = nextTheme;

        follower.style.setProperty('--cursor-fill', themeValues[nextTheme].fill);
        follower.style.setProperty('--cursor-glow', themeValues[nextTheme].glow);
        follower.style.setProperty('--cursor-foreground', themeValues[nextTheme].foreground);
        follower.style.setProperty('--cursor-stroke', themeValues[nextTheme].stroke);
    };

    const getCursorTypeFromElement = (element) => {
        if (!(element instanceof Element)) {
            return '';
        }

        const cursorHost = element.closest('[data-cursor]');
        const bigPlayHost = element.closest('.v-bigPlay');
        const vliteHost = cursorHost?.closest('.v-vlite') || bigPlayHost?.closest('.v-vlite');

        if (vliteHost && vliteHost.classList.contains('v-playing')) {
            if (cursorHost) {
                const explicitCursorType = String(cursorHost.getAttribute('data-cursor') || '').trim().toLowerCase();
                if (explicitCursorType === 'play') {
                    return 'pause';
                }
            }

            if (bigPlayHost) {
                return 'pause';
            }
        }

        if (!cursorHost) {
            return bigPlayHost ? 'play' : '';
        }

        const explicitCursorType = String(cursorHost.getAttribute('data-cursor') || '').trim().toLowerCase();
        if (explicitCursorType) {
            return explicitCursorType;
        }

        return bigPlayHost ? 'play' : '';
    };

    const refreshCursorFromPointer = () => {
        const elementUnderPointer = document.elementFromPoint(targetX, targetY);
        if (!(elementUnderPointer instanceof Element)) {
            return;
        }

        const interactiveElement = resolveInteractive(elementUnderPointer);
        isGrow = Boolean(interactiveElement);
        syncTheme(interactiveElement || elementUnderPointer);
        syncCursorType(interactiveElement || elementUnderPointer);
        syncGrow();
    };

    const syncCursorType = (element) => {
        const nextCursorType = getCursorTypeFromElement(element);
        if (nextCursorType === currentCursorType) {
            return;
        }

        currentCursorType = nextCursorType;

        if (nextCursorType) {
            follower.dataset.cursor = nextCursorType;
        } else {
            delete follower.dataset.cursor;
        }

        follower.classList.toggle('has-icon', Boolean(cursorTypeIcons[nextCursorType]));
    };

    const render = () => {
        currentX += (targetX - currentX) * 0.14;
        currentY += (targetY - currentY) * 0.14;
        currentScale += (targetScale - currentScale) * 0.2;

        follower.style.transform = `translate3d(${currentX}px, ${currentY}px, 0) translate(-50%, -50%) scale(${currentScale})`;

        if (
            Math.abs(targetX - currentX) > 0.1 ||
            Math.abs(targetY - currentY) > 0.1 ||
            Math.abs(targetScale - currentScale) > 0.001
        ) {
            frameId = window.requestAnimationFrame(render);
            return;
        }

        frameId = null;
    };

    const requestRender = () => {
        if (frameId !== null) {
            return;
        }
        frameId = window.requestAnimationFrame(render);
    };

    const syncVisibility = () => {
        follower.classList.toggle('is-visible', isVisible);
    };

    const syncGrow = () => {
        if (isPressed) {
            targetScale = isGrow ? pressedScale : pressedIdleScale;
        } else {
            targetScale = isGrow ? hoverScale : idleScale;
        }

        if (isGrow) {
            follower.style.setProperty('--cursor-fill', 'rgba(0, 239, 250, 0.26)');
            follower.style.setProperty('--cursor-glow', 'rgba(110, 244, 250, 0.24)');
            follower.style.setProperty('--cursor-foreground', '#000000');
        } else {
            follower.style.setProperty('--cursor-fill', themeValues[currentTheme].fill);
            follower.style.setProperty('--cursor-glow', themeValues[currentTheme].glow);
            follower.style.setProperty('--cursor-foreground', themeValues[currentTheme].foreground);
        }

        follower.classList.toggle('is-grow', isGrow);
        follower.classList.toggle('is-pressed', isPressed);
        requestRender();
    };

    const resolveInteractive = (element) => {
        if (!(element instanceof Element)) {
            return null;
        }
        return element.closest(interactiveSelector);
    };

    document.addEventListener('pointermove', (event) => {
        if (event.pointerType && event.pointerType !== 'mouse') {
            return;
        }

        targetX = event.clientX;
        targetY = event.clientY;

        if (!isVisible) {
            isVisible = true;
            syncVisibility();
        }

        const interactiveElement = resolveInteractive(event.target);

        isGrow = Boolean(interactiveElement);
        syncTheme(interactiveElement || event.target);
        syncCursorType(interactiveElement || event.target);
        syncGrow();
        requestRender();
    }, { passive: true });

    document.addEventListener('mouseout', (event) => {
        if (!event.relatedTarget) {
            isVisible = false;
            isGrow = false;
            isPressed = false;
            syncVisibility();
            syncCursorType(null);
            syncGrow();
            return;
        }
    });

    document.addEventListener('mousedown', () => {
        isPressed = true;
        syncGrow();
    });

    document.addEventListener('mouseup', () => {
        const elementUnderPointer = document.elementFromPoint(targetX, targetY);
        const hoveredElement = resolveInteractive(elementUnderPointer);
        isPressed = false;
        syncTheme(elementUnderPointer);
        syncCursorType(hoveredElement || elementUnderPointer);
        isGrow = Boolean(hoveredElement);
        syncGrow();
    });

    document.addEventListener('play', refreshCursorFromPointer, true);
    document.addEventListener('pause', refreshCursorFromPointer, true);

    window.addEventListener('blur', () => {
        isVisible = false;
        isGrow = false;
        isPressed = false;
        syncVisibility();
        syncCursorType(null);
        syncGrow();
    });

    const handleToTouch = () => {
        if (!hoverQuery.matches || !finePointerQuery.matches || reducedMotionQuery.matches) {
            hoverQuery.removeEventListener('change', handleToTouch);
            finePointerQuery.removeEventListener('change', handleToTouch);
            if (frameId !== null) {
                cancelAnimationFrame(frameId);
                frameId = null;
            }
            follower.remove();
            delete document.body.dataset.cursorFollower;
            document.documentElement.classList.remove('has-cursor-follower');
            initGlobalCursorFollower();
        }
    };
    hoverQuery.addEventListener('change', handleToTouch);
    finePointerQuery.addEventListener('change', handleToTouch);
}
// end: initGlobalCursorFollower



//// // // // // //  NUEVO // // // // // // 
let swiperProyectosInstance = null;
let proyectoDestacadoCtaMotionCleanup = null;

// Inicia el swiper de proyectos solo bajo el breakpoint md.
// start: Activa el swiper de proyectos solo en pantallas pequeñas y lo destruye al salir de ese breakpoint.
function initSwiperProyectos() {
    const container = document.querySelector('.c-swiper-proyectos');
    if (!container || typeof Swiper === 'undefined') {
        return;
    }

    const mql = window.matchMedia('(max-width: 992px)');
    const handleChange = () => {
        if (mql.matches) {
            if (!swiperProyectosInstance) {
                swiperProyectosInstance = new Swiper(container, {
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                    watchOverflow: true,
                });
            }
        } else if (swiperProyectosInstance) {
            swiperProyectosInstance.destroy(true, true);
            swiperProyectosInstance = null;
        }
    };

    handleChange();
    if (typeof mql.addEventListener === 'function') {
        mql.addEventListener('change', handleChange);
    } else {
        mql.addListener(handleChange);
    }
}
// end: initSwiperProyectos

// start: Reproduce y reinicia los videos al hacer hover o focus en proyectos destacados.
function initProyectoHoverVideos() {
    const links = document.querySelectorAll('.c-card-proyecto .link-absolute');
    if (!links.length) {
        return;
    }

    links.forEach((link) => {
        const card = link.closest('.c-card-proyecto');
        const video = card ? card.querySelector('.c-card-proyecto_media video') : null;
        if (!video) {
            return;
        }

        const playVideo = () => {
            video.muted = true;
            video.playsInline = true;
            if (video.readyState >= 1) {
                try {
                    video.currentTime = 0;
                } catch (error) {
                    // Ignore seek errors for unloaded videos.
                }
            } else {
                video.addEventListener('loadedmetadata', () => {
                    try {
                        video.currentTime = 0;
                    } catch (error) {
                        // Ignore seek errors for unloaded videos.
                    }
                }, { once: true });
            }

            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(() => { });
            }
        };

        const resetVideo = () => {
            video.pause();
            try {
                video.currentTime = 0;
            } catch (error) {
                // Ignore seek errors for unloaded videos.
            }
        };

        link.addEventListener('mouseenter', playVideo);
        link.addEventListener('focus', playVideo);
        link.addEventListener('mouseleave', resetVideo);
        link.addEventListener('blur', resetVideo);
    });
}
// end: initProyectoHoverVideos

// start: Muestra una etiqueta "Ver proyecto" que sigue el cursor sobre cada overlay link.
function initProyectoDestacadoCursor() {
    const links = document.querySelectorAll('.c-proy-des_link');
    if (!links.length) {
        return;
    }

    const desktopQuery = window.matchMedia('(min-width: 768px)');

    links.forEach((link) => {
        if (link.dataset.cursorBound === 'true') {
            return;
        }
        link.dataset.cursorBound = 'true';

        const setPointerPosition = (event) => {
            if (!desktopQuery.matches) {
                return;
            }
            const rect = link.getBoundingClientRect();
            link.style.setProperty('--cursor-x', `${event.clientX - rect.left}px`);
            link.style.setProperty('--cursor-y', `${event.clientY - rect.top}px`);
        };

        const showHover = (event) => {
            if (!desktopQuery.matches) {
                return;
            }
            link.classList.add('is-hover');
            if (event) {
                setPointerPosition(event);
            }
        };

        const hideHover = () => {
            link.classList.remove('is-hover');
        };

        const syncMode = () => {
            if (desktopQuery.matches) {
                return;
            }
            hideHover();
            link.style.removeProperty('--cursor-x');
            link.style.removeProperty('--cursor-y');
        };

        link.addEventListener('mouseenter', showHover);
        link.addEventListener('mousemove', setPointerPosition);
        link.addEventListener('mouseleave', hideHover);
        link.addEventListener('focus', () => {
            if (!desktopQuery.matches) {
                return;
            }
            link.classList.add('is-hover');
            link.style.setProperty('--cursor-x', '50%');
            link.style.setProperty('--cursor-y', '50%');
        });
        link.addEventListener('blur', hideHover);

        if (typeof desktopQuery.addEventListener === 'function') {
            desktopQuery.addEventListener('change', syncMode);
        } else if (typeof desktopQuery.addListener === 'function') {
            desktopQuery.addListener(syncMode);
        }

        syncMode();
    });

    const cards = document.querySelectorAll('.c-proy-des[data-cursor]');
    if (cards.length) {
        const belowMdQuery = window.matchMedia('(max-width: 991.98px)');
        const cursorValues = new Map(Array.from(cards).map((c) => [c, c.dataset.cursor]));

        const syncCardCursor = () => {
            cards.forEach((card) => {
                if (belowMdQuery.matches) {
                    delete card.dataset.cursor;
                } else {
                    card.dataset.cursor = cursorValues.get(card);
                }
            });
        };

        belowMdQuery.addEventListener('change', syncCardCursor);
        syncCardCursor();
    }
}
// end: initProyectoDestacadoCursor

// start: Mueve el CTA de proyectos destacados dentro de su contenedor siguiendo el progreso del scroll del bloque.
function initProyectoDestacadoCtaMotion() {
    if (typeof gsap === 'undefined') {
        return;
    }

    if (typeof proyectoDestacadoCtaMotionCleanup === 'function') {
        proyectoDestacadoCtaMotionCleanup();
        proyectoDestacadoCtaMotionCleanup = null;
    }

    const cards = Array.from(document.querySelectorAll('.c-proy-des'));
    if (!cards.length) {
        return;
    }

    const items = cards.map((card) => {
        const layer = card.querySelector('.c-proy-des_cta-layer');
        const cta = card.querySelector('.c-proy-des_cta');
        if (!layer || !cta) {
            return null;
        }

        return {
            card,
            layer,
            cta,
            setY: gsap.quickTo(cta, 'y', {
                duration: 0.65,
                ease: 'power3.out',
                overwrite: true
            })
        };
    }).filter(Boolean);

    if (!items.length) {
        return;
    }

    const desktopQuery = window.matchMedia('(min-width: 768px)');
    const resizeObserver = typeof ResizeObserver === 'function'
        ? new ResizeObserver(() => scheduleUpdate(true))
        : null;

    let rafId = null;
    let resizeTimeout = null;
    let isDesktopActive = false;

    function clearTransforms() {
        items.forEach(({ cta }) => {
            gsap.killTweensOf(cta);
            gsap.set(cta, { clearProps: 'transform' });
        });
    }

    function getScrollY() {
        return window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
    }

    function applyPositions() {
        rafId = null;

        if (!isDesktopActive) {
            return;
        }

        const scrollY = getScrollY();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

        items.forEach(({ layer, cta, setY }) => {
            const rect = layer.getBoundingClientRect();
            const docTop = rect.top + scrollY;
            const docBottom = docTop + layer.offsetHeight;
            const maxY = Math.max(layer.offsetHeight - cta.offsetHeight, 0);
            const start = docTop - viewportHeight * 0.95;
            const end = docBottom - viewportHeight * 0.70;
            const distance = Math.max(end - start, 1);
            const progress = gsap.utils.clamp(0, 1, (scrollY - start) / distance);

            setY(maxY * progress);
        });
    }

    function scheduleUpdate(forceImmediate = false) {
        if (!isDesktopActive) {
            return;
        }

        if (forceImmediate) {
            if (rafId !== null) {
                window.cancelAnimationFrame(rafId);
                rafId = null;
            }
            applyPositions();
            return;
        }

        if (rafId !== null) {
            return;
        }

        rafId = window.requestAnimationFrame(applyPositions);
    }

    function handleResize() {
        if (!isDesktopActive) {
            return;
        }

        window.clearTimeout(resizeTimeout);
        resizeTimeout = window.setTimeout(() => {
            scheduleUpdate(true);
        }, 180);
    }

    function enableDesktop() {
        if (isDesktopActive) {
            return;
        }

        isDesktopActive = true;
        scheduleUpdate(true);
        window.requestAnimationFrame(() => {
            scheduleUpdate(true);
        });
    }

    function disableDesktop() {
        if (!isDesktopActive) {
            return;
        }

        isDesktopActive = false;
        if (rafId !== null) {
            window.cancelAnimationFrame(rafId);
            rafId = null;
        }
        window.clearTimeout(resizeTimeout);
        clearTransforms();
    }

    function syncMode() {
        if (desktopQuery.matches) {
            enableDesktop();
            return;
        }

        disableDesktop();
    }

    const handleScroll = () => {
        scheduleUpdate();
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleResize, { passive: true });
    window.addEventListener('load', handleResize);

    if (typeof desktopQuery.addEventListener === 'function') {
        desktopQuery.addEventListener('change', syncMode);
    } else if (typeof desktopQuery.addListener === 'function') {
        desktopQuery.addListener(syncMode);
    }

    if (resizeObserver) {
        items.forEach(({ card, layer, cta }) => {
            resizeObserver.observe(card);
            resizeObserver.observe(layer);
            resizeObserver.observe(cta);
        });
    }

    syncMode();

    proyectoDestacadoCtaMotionCleanup = () => {
        disableDesktop();
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', handleResize);
        window.removeEventListener('load', handleResize);

        if (typeof desktopQuery.removeEventListener === 'function') {
            desktopQuery.removeEventListener('change', syncMode);
        } else if (typeof desktopQuery.removeListener === 'function') {
            desktopQuery.removeListener(syncMode);
        }

        if (resizeObserver) {
            resizeObserver.disconnect();
        }
    };
}
// end: initProyectoDestacadoCtaMotion

// start: Convierte un color CSS RGB/RGBA en canales numéricos utilizables.
function parseMenuToggleColor(colorValue) {
    if (!colorValue || typeof colorValue !== 'string') {
        return null;
    }

    const channels = colorValue.match(/[\d.]+/g);

    if (!channels || channels.length < 3) {
        return null;
    }

    return {
        r: Number.parseFloat(channels[0]),
        g: Number.parseFloat(channels[1]),
        b: Number.parseFloat(channels[2]),
        a: channels[3] !== undefined ? Number.parseFloat(channels[3]) : 1
    };
}
// end: parseMenuToggleColor

// start: Calcula la luminancia relativa de un color para decidir si el fondo es claro u oscuro.
function getMenuToggleColorLuminance({ r, g, b }) {
    const normalizeChannel = (value) => {
        const channel = value / 255;
        return channel <= 0.03928
            ? channel / 12.92
            : ((channel + 0.055) / 1.055) ** 2.4;
    };

    return (
        0.2126 * normalizeChannel(r) +
        0.7152 * normalizeChannel(g) +
        0.0722 * normalizeChannel(b)
    );
}
// end: getMenuToggleColorLuminance

// start: Resuelve el tono del fondo a partir de un elemento o sus ancestros, con soporte para atributos de tema.
function getMenuToggleToneFromElement(element) {
    let current = element;

    while (current && current !== document.documentElement) {
        if (current.dataset) {
            if (current.dataset.cursorTheme === 'dark' || current.dataset.cursorTheme === 'light') {
                return current.dataset.cursorTheme;
            }

            if (current.dataset.navTone === 'dark' || current.dataset.navTone === 'light') {
                return current.dataset.navTone;
            }
        }

        const styles = window.getComputedStyle(current);

        const hasBackgroundImage = styles.backgroundImage && styles.backgroundImage !== 'none';
        const hasGradientBackground = hasBackgroundImage && styles.backgroundImage.includes('gradient');

        if (hasBackgroundImage && !hasGradientBackground) {
            current = current.parentElement;
            continue;
        }

        const color = parseMenuToggleColor(styles.backgroundColor);

        if (color && color.a > 0.85) {
            return getMenuToggleColorLuminance(color) < 0.42 ? 'dark' : 'light';
        }

        current = current.parentElement;
    }

    const bodyColor = parseMenuToggleColor(window.getComputedStyle(document.body).backgroundColor);
    if (!bodyColor) {
        return 'light';
    }

    return getMenuToggleColorLuminance(bodyColor) < 0.42 ? 'dark' : 'light';
}
// end: getMenuToggleToneFromElement

// start: Detecta el tono real del fondo justo debajo del botón de menú.
function detectMenuToggleTone(nav, menuToggle) {
    if (!nav || !menuToggle) {
        return 'light';
    }

    const rect = menuToggle.getBoundingClientRect();
    const sampleX = Math.min(Math.max(rect.left + rect.width / 2, 0), window.innerWidth - 1);
    const sampleY = Math.min(Math.max(rect.top + rect.height / 2, 0), window.innerHeight - 1);
    const elements = document.elementsFromPoint(sampleX, sampleY);

    for (const element of elements) {
        if (!(element instanceof Element)) {
            continue;
        }

        if (nav.contains(element) || element.closest('.main-nav')) {
            continue;
        }

        return getMenuToggleToneFromElement(element);
    }

    return getMenuToggleToneFromElement(document.body);
}
// end: detectMenuToggleTone

// start: Controla la apertura y cierre del menú principal y sincroniza el bloqueo de scroll del body.
function btnMenu() {
    const nav = document.querySelector('.main-nav');
    const menuToggle = nav ? nav.querySelector('.btn-open-menu') : null;
    const menuPanel = nav ? nav.querySelector('#site-menu') : null;
    const menuCurtain = menuPanel ? menuPanel.querySelector('.menu-curtain') : null;
    const curtainParts = menuCurtain ? Array.from(menuCurtain.querySelectorAll('.curtain-part')) : [];
    const menuScrollLayer = menuPanel ? menuPanel.querySelector('.main-nav_menu-scroll') : null;
    const menuLayers = menuScrollLayer ? [menuScrollLayer] : [];
    const navPrimaryItems = menuPanel
        ? Array.from(menuPanel.querySelectorAll('.nav-primary > li'))
        : [];
    const menuContact = menuPanel ? menuPanel.querySelector('.main-nav_menu-inner .contact') : null;

    if (!nav || !menuToggle || !menuPanel || menuToggle.dataset.menuBound === 'true') {
        return;
    }

    header = nav;
    menuToggle.dataset.menuBound = 'true';
    menuPanel.classList.add('main-nav_menu');

    let menuOpen = nav.classList.contains('menu-open');
    let isAnimating = false;
    let activeTimeline = null;
    let menuToneFrame = null;
    const mobileCurtainMedia = window.matchMedia('(max-width: 739.98px)');
    const tabletMenuAnimationMedia = window.matchMedia('(max-width: 991.98px)');

    const getActiveCurtainParts = () => {
        if (mobileCurtainMedia.matches) {
            return curtainParts.slice(0, 2);
        }

        return curtainParts;
    };

    const applyMenuToggleTone = (tone) => {
        nav.classList.toggle('menu-toggle-on-dark', tone === 'dark');
        nav.classList.toggle('menu-toggle-on-light', tone !== 'dark');
    };

    const syncMenuToggleTone = () => {
        if (menuOpen) {
            applyMenuToggleTone('dark');
            return;
        }

        applyMenuToggleTone(detectMenuToggleTone(nav, menuToggle));
    };

    const queueMenuToggleToneSync = () => {
        if (menuToneFrame !== null) {
            return;
        }

        menuToneFrame = window.requestAnimationFrame(() => {
            menuToneFrame = null;
            syncMenuToggleTone();
        });
    };

    // const syncBodyScrollLock = () => {
    //     const shouldLock = menuPanel.classList.contains('header-menu-active') && window.innerWidth < 1200;
    //     document.body.classList.toggle('open-menu', shouldLock);
    //     document.body.classList.toggle('no-scroll', shouldLock);
    // };

    const syncToggleState = (isOpen) => {
        nav.classList.toggle('menu-open', isOpen);
        menuToggle.classList.toggle('is-active', isOpen);
        menuToggle.setAttribute('aria-expanded', String(isOpen));
        menuToggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
        queueMenuToggleToneSync();
    };

    const openMenuCurtain = () => {
        if (isAnimating || menuOpen) {
            return;
        }

        menuOpen = true;
        isAnimating = true;
        syncToggleState(true);
        menuPanel.classList.add('header-menu-active');
        menuPanel.setAttribute('aria-hidden', 'false');
        // syncBodyScrollLock();
        document.body.classList.add('open-menu');
        const activeCurtainParts = getActiveCurtainParts();
        const navPrimaryIntroStart = 0.4;
        const navPrimaryIntroDuration = 0.4;
        const navPrimaryIntroStagger = 0.06;
        const navPrimaryIntroEnd = navPrimaryItems.length
            ? navPrimaryIntroStart + navPrimaryIntroDuration + navPrimaryIntroStagger * Math.max(navPrimaryItems.length - 1, 0)
            : navPrimaryIntroStart;
        const menuContactIntroStart = tabletMenuAnimationMedia.matches
            ? Math.max(navPrimaryIntroStart, navPrimaryIntroEnd - 0.2)
            : 0.65;

        if (typeof gsap === 'undefined' || !activeCurtainParts.length) {
            isAnimating = false;
            return;
        }

        if (activeTimeline) {
            activeTimeline.kill();
        }

        menuCurtain.style.visibility = 'visible';
        gsap.set(menuPanel, { autoAlpha: 1 });
        gsap.set(menuCurtain, { opacity: 0 });
        gsap.set(curtainParts, { yPercent: 0 });
        gsap.set(activeCurtainParts, { yPercent: -100 });
        gsap.set(menuLayers, { autoAlpha: 0, y: -24 });
        gsap.set(navPrimaryItems, { autoAlpha: 0, y: -24 });
        if (menuContact) gsap.set(menuContact, { autoAlpha: 0, y: -24 });

        activeTimeline = gsap.timeline({
            defaults: { overwrite: true },
            onComplete: () => {
                isAnimating = false;
                activeTimeline = null;
            }
        });

        activeTimeline.to(menuCurtain, {
            opacity: 1,
            duration: 0.3,
            ease: 'power2.out'
        }, 0);

        activeCurtainParts.forEach((part, index) => {
            activeTimeline.fromTo(part, {
                yPercent: -100,
            }, {
                yPercent: 0,
                duration: 0.8,
                ease: 'power3.out'
            }, index * 0.2);
        });

        if (menuLayers.length) {
            activeTimeline.to(menuLayers, {
                autoAlpha: 1,
                y: 0,
                duration: 0.28,
                ease: 'power2.out'
            }, 0.16);
        }

        if (navPrimaryItems.length) {
            activeTimeline.to(navPrimaryItems, {
                autoAlpha: 1,
                y: 0,
                duration: navPrimaryIntroDuration,
                stagger: navPrimaryIntroStagger,
                ease: 'power2.out'
            }, navPrimaryIntroStart);
        }

        if (menuContact) {
            activeTimeline.to(menuContact, {
                autoAlpha: 1,
                y: 0,
                duration: 0.35,
                ease: 'power2.out'
            }, menuContactIntroStart);
        }
    };

    const closeMenuCurtain = () => {
        if (isAnimating || !menuOpen) {
            return;
        }

        menuOpen = false;
        isAnimating = true;
        syncToggleState(false);
        const activeCurtainParts = getActiveCurtainParts();
        const navPrimaryOutroStart = tabletMenuAnimationMedia.matches ? 0.22 : 0.15;
        const menuContactOutroStart = tabletMenuAnimationMedia.matches ? 0.1 : 0.12;
        document.body.classList.remove('open-menu');
        if (typeof gsap === 'undefined' || !activeCurtainParts.length) {
            menuPanel.classList.remove('header-menu-active');
            menuPanel.setAttribute('aria-hidden', 'true');
            // syncBodyScrollLock();
            isAnimating = false;
            return;
        }

        if (activeTimeline) {
            activeTimeline.kill();
        }

        activeTimeline = gsap.timeline({
            defaults: { overwrite: true },
            onComplete: () => {
                menuCurtain.style.visibility = 'hidden';
                menuPanel.classList.remove('header-menu-active');
                menuPanel.setAttribute('aria-hidden', 'true');
                gsap.set(menuPanel, { autoAlpha: 0 });
                gsap.set(menuCurtain, { opacity: 0 });
                gsap.set(curtainParts, { yPercent: 0 });
                gsap.set(menuLayers, { autoAlpha: 0, y: 24 });
                gsap.set(navPrimaryItems, { autoAlpha: 0, y: 18 });
                if (menuContact) gsap.set(menuContact, { autoAlpha: 0, y: -18 });
                // syncBodyScrollLock();
                isAnimating = false;
                activeTimeline = null;
            }
        });
        if (navPrimaryItems.length) {
            activeTimeline.to(navPrimaryItems, {
                autoAlpha: 0,
                y: -14,
                duration: 0.3,
                stagger: {
                    each: 0.05,
                    from: 'end'
                },
                ease: 'power2.in'
            }, navPrimaryOutroStart);
        }

        if (menuContact) {
            activeTimeline.to(menuContact, {
                autoAlpha: 0,
                y: -16,
                duration: 0.22,
                ease: 'power2.in'
            }, menuContactOutroStart);
        }

        if (menuLayers.length) {
            activeTimeline.to(menuLayers, {
                autoAlpha: 0,
                y: 20,
                duration: 0.18,
                ease: 'power2.in'
            }, 0.35);
        }

        activeCurtainParts.slice().reverse().forEach((part, index) => {
            activeTimeline.to(part, {
                yPercent: -100,
                duration: 0.82,
                ease: 'power3.inOut'
                // ease: 'back.in(1.2)'
            }, 0.1 + index * 0.15);
        }, 0.25);


        activeTimeline.to(menuCurtain, {
            opacity: 0,
            duration: 0.4,
            ease: 'power2.out'
        }, 0.8);
    };

    menuToggle.addEventListener('click', () => {
        if (menuOpen) {
            closeMenuCurtain();
            return;
        }

        openMenuCurtain();
    });

    menuPanel.addEventListener('click', (event) => {
        if (event.target.closest('a')) {
            closeMenuCurtain();
        }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && menuOpen) {
            closeMenuCurtain();
        }
    });
    window.addEventListener('scroll', queueMenuToggleToneSync, { passive: true });
    window.addEventListener('resize', queueMenuToggleToneSync);
    window.addEventListener('load', queueMenuToggleToneSync);
    // window.addEventListener('resize', syncBodyScrollLock);

    syncToggleState(menuOpen);
    menuPanel.classList.toggle('header-menu-active', menuOpen);
    menuPanel.setAttribute('aria-hidden', String(!menuOpen));

    if (typeof gsap !== 'undefined' && curtainParts.length) {
        const activeCurtainParts = getActiveCurtainParts();
        gsap.set(menuPanel, { autoAlpha: menuOpen ? 1 : 0 });
        gsap.set(curtainParts, { yPercent: 0 });
        gsap.set(menuCurtain, { opacity: menuOpen ? 1 : 0 });
        gsap.set(activeCurtainParts, { yPercent: menuOpen ? 0 : 0 });
        gsap.set(menuLayers, {
            autoAlpha: menuOpen ? 1 : 0,
            y: menuOpen ? 0 : 24
        });
        gsap.set(navPrimaryItems, {
            autoAlpha: menuOpen ? 1 : 0,
            y: menuOpen ? 0 : 18
        });
        if (menuContact) gsap.set(menuContact, {
            autoAlpha: menuOpen ? 1 : 0,
            y: menuOpen ? 0 : -18
        });
        menuCurtain.style.visibility = menuOpen ? 'visible' : 'hidden';
    }

    queueMenuToggleToneSync();

    // syncBodyScrollLock();
}
// end: btnMenu

// start: Gestiona la apertura de submenús en móvil y resetea su estado al volver a escritorio.
function openMenuSub() {
    const menuRoot = document.querySelector('.main-nav_menu .nav-primary');
    if (!menuRoot) {
        return;
    }

    const submenuTriggers = menuRoot.querySelectorAll('.hover-submenu > .btn');
    if (!submenuTriggers.length) {
        return;
    }

    const isDesktopMenu = () => window.matchMedia('(min-width: 1200px)').matches;

    const collapseAllSubmenus = () => {
        submenuTriggers.forEach((itemTrigger) => {
            const item = itemTrigger.closest('.hover-submenu');
            if (!item) {
                return;
            }
            item.classList.remove('submenu-open');
            itemTrigger.setAttribute('aria-expanded', 'false');
        });
    };

    const syncSubmenuMode = () => {
        if (isDesktopMenu()) {
            collapseAllSubmenus();
        }
    };

    submenuTriggers.forEach((trigger) => {
        if (trigger.dataset.submenuBound === 'true') {
            return;
        }

        trigger.dataset.submenuBound = 'true';
        trigger.setAttribute('aria-expanded', 'false');

        trigger.addEventListener('click', (event) => {
            if (isDesktopMenu()) {
                return;
            }

            event.preventDefault();

            const submenuItem = trigger.closest('.hover-submenu');
            if (!submenuItem) {
                return;
            }

            const willOpen = !submenuItem.classList.contains('submenu-open');

            collapseAllSubmenus();

            submenuItem.classList.toggle('submenu-open', willOpen);
            trigger.setAttribute('aria-expanded', String(willOpen));
        });
    });

    if (menuRoot.dataset.submenuResizeBound !== 'true') {
        menuRoot.dataset.submenuResizeBound = 'true';
        window.addEventListener('resize', syncSubmenuMode);
    }

    syncSubmenuMode();
}
// end: openMenuSub

// start: Inicializa el showcase circular de proyectos con rueda, drag, tilt y sincronización de metadatos.
function initProjectsShowcase() {
    const root = document.querySelector('[data-projects-showcase]');
    if (!root || typeof gsap === 'undefined') {
        return;
    }

    if (typeof root._projectsCleanup === 'function') {
        root._projectsCleanup();
    }

    const stage = root.querySelector('.c-proyectos_stage');
    const items = Array.from(root.querySelectorAll('[data-project-item]'));
    const metaRows = Array.from(root.querySelectorAll('[data-project-meta]'));
    const mobileCards = Array.from(root.querySelectorAll('[data-project-mobile-card]'));
    const infoCards = Array.from(root.querySelectorAll('[data-project-info-card]'));
    const count = items.length;

    if (!stage || !count) {
        return;
    }

    const state = {
        progress: 0,
        activeIndex: 0,
        isMobile: window.matchMedia('(max-width: 991px)').matches,
        itemGap: 0,
        nameGap: 0,
        wheelTween: null,
        snapTween: null
    };

    const cleanups = [];
    const proxy = document.createElement('div');
    let dragStartProgress = 0;
    let lastProgress = 0;
    let lastTime = performance.now();

    function wrapProgress(value) {
        const wrapped = value % count;
        return wrapped < 0 ? wrapped + count : wrapped;
    }

    function wrapDelta(value) {
        let delta = value % count;
        const half = count / 2;

        if (delta > half) {
            delta -= count;
        }

        if (delta < -half) {
            delta += count;
        }

        return delta;
    }

    function resetActiveTilt() {
        const activeItem = items[state.activeIndex];
        if (!activeItem) {
            return;
        }

        const itemInner = activeItem.querySelector('.c-proyectos_item-inner');
        const image = activeItem.querySelector('img');

        gsap.to(itemInner, {
            rotationX: 0,
            rotationY: 0,
            z: 0,
            duration: 0.55,
            ease: 'power3.out',
            overwrite: true
        });

        gsap.to(image, {
            xPercent: 0,
            yPercent: 0,
            scale: 1.02,
            duration: 0.55,
            ease: 'power3.out',
            overwrite: true
        });
    }

    function updateActiveIndex(force) {
        const nextIndex = wrapProgress(Math.round(state.progress));

        if (!force && nextIndex === state.activeIndex) {
            return;
        }

        state.activeIndex = nextIndex;

        items.forEach((item, index) => {
            item.classList.toggle('is-active', index === nextIndex);
            item.style.pointerEvents = 'auto';
        });

        metaRows.forEach((item, index) => {
            item.classList.toggle('is-active', index === nextIndex);
        });

        mobileCards.forEach((item, index) => {
            item.classList.toggle('is-active', index === nextIndex);
        });

        infoCards.forEach((item, index) => {
            item.classList.toggle('is-active', index === nextIndex);
        });

        resetActiveTilt();
    }

    function render() {
        updateActiveIndex(false);

        items.forEach((item, index) => {
            const delta = wrapDelta(index - state.progress);
            const distance = Math.abs(delta);
            const offset = delta * state.itemGap;
            const opacity = gsap.utils.interpolate(1, 0.18, Math.min(distance / 1.2, 1));
            const scale = state.isMobile
                ? gsap.utils.interpolate(1.02, 0.82, Math.min(distance / 1.1, 1))
                : gsap.utils.interpolate(1.08, 0.7, Math.min(distance / 1.25, 1));

            gsap.set(item, {
                xPercent: -50,
                yPercent: -50,
                x: state.isMobile ? offset : 0,
                y: state.isMobile ? 0 : offset,
                rotation: state.isMobile ? delta * -7 : delta * -10,
                scale,
                autoAlpha: opacity,
                zIndex: Math.round(200 - distance * 100)
            });
        });

        metaRows.forEach((item, index) => {
            const delta = wrapDelta(index - state.progress);
            const distance = Math.abs(delta);

            gsap.set(item, {
                y: delta * state.nameGap,
                autoAlpha: gsap.utils.interpolate(1, 0.08, Math.min(distance / 1, 1))
            });
        });

        mobileCards.forEach((item, index) => {
            const delta = wrapDelta(index - state.progress);
            const distance = Math.abs(delta);

            gsap.set(item, {
                y: distance < 0.65 ? delta * 30 : delta * 44,
                autoAlpha: gsap.utils.interpolate(1, 0, Math.min(distance / 0.85, 1))
            });
        });

        infoCards.forEach((item, index) => {
            const delta = wrapDelta(index - state.progress);
            const distance = Math.abs(delta);

            gsap.set(item, {
                y: distance < 0.7 ? delta * 20 : delta * 30,
                autoAlpha: gsap.utils.interpolate(1, 0, Math.min(distance / 0.9, 1))
            });
        });
    }

    function snapToNearest() {
        const destination = resolveNearestProgress(Math.round(state.progress));

        if (state.snapTween) {
            state.snapTween.kill();
        }

        state.snapTween = gsap.to(state, {
            progress: destination,
            duration: 0.45,
            ease: 'power2.out',
            overwrite: true,
            onUpdate: render
        });
    }

    function resolveNearestProgress(targetIndex) {
        const current = state.progress;
        const target = wrapProgress(targetIndex);
        const delta = wrapDelta(target - current);
        return current + delta;
    }

    function nudgeProgress(delta) {
        if (!delta) {
            return;
        }

        if (state.wheelTween) {
            state.wheelTween.kill();
        }

        if (state.snapTween) {
            state.snapTween.kill();
        }

        state.wheelTween = gsap.to(state, {
            progress: state.progress + delta,
            duration: 0.55,
            ease: 'power3.out',
            overwrite: true,
            onUpdate: render,
            onComplete: snapToNearest
        });
    }

    function buildMetrics() {
        state.isMobile = window.matchMedia('(max-width: 991px)').matches;
        state.itemGap = state.isMobile
            ? Math.max(window.innerWidth * 0.6, 220)
            : Math.max(stage.offsetHeight * 0.46, 190);
        state.nameGap = state.isMobile ? 0 : Math.max(stage.offsetHeight * 0.13, 70);
    }

    function handlePointerMove(event) {
        if (state.isMobile) {
            return;
        }

        const activeItem = items[state.activeIndex];
        if (!activeItem) {
            return;
        }

        const itemInner = activeItem.querySelector('.c-proyectos_item-inner');
        const image = activeItem.querySelector('img');
        const bounds = stage.getBoundingClientRect();
        const centerX = bounds.left + bounds.width / 2;
        const centerY = bounds.top + bounds.height / 2;
        const offsetX = (event.clientX - centerX) / Math.max(bounds.width / 2, 1);
        const offsetY = (event.clientY - centerY) / Math.max(bounds.height / 2, 1);
        const rotateY = gsap.utils.clamp(-8, 8, offsetX * 8);
        const rotateX = gsap.utils.clamp(-8, 8, offsetY * -8);
        const imageShiftX = gsap.utils.clamp(-4.5, 4.5, rotateY * 0.55);
        const imageShiftY = gsap.utils.clamp(-4.5, 4.5, rotateX * -0.55);

        gsap.to(itemInner, {
            rotationX: rotateX,
            rotationY: rotateY,
            z: 20,
            transformPerspective: 1200,
            duration: 0.55,
            ease: 'power3.out',
            overwrite: true
        });

        gsap.to(image, {
            xPercent: imageShiftX,
            yPercent: imageShiftY,
            scale: 1.12,
            duration: 0.55,
            ease: 'power3.out',
            overwrite: true
        });
    }

    function handleTick() {
        const now = performance.now();
        const dt = Math.max((now - lastTime) / 1000, 0.001);
        const delta = wrapDelta(state.progress - lastProgress);
        const velocity = Math.abs(delta / dt);
        const blurAmount = gsap.utils.clamp(0, 16, velocity * 7);
        const noteOpacity = gsap.utils.clamp(0.25, 1, 1 - velocity * 0.4);

        root.style.setProperty('--projects-blur', `${blurAmount.toFixed(2)}px`);

        lastProgress = state.progress;
        lastTime = now;
    }

    function handleResize() {
        const wasMobile = state.isMobile;
        buildMetrics();

        if (wasMobile !== state.isMobile) {
            initProjectsShowcase();
            return;
        }

        render();
        resetActiveTilt();
    }

    buildMetrics();
    updateActiveIndex(true);
    render();

    items.forEach((item, index) => {
        const handleClick = () => {
            const destination = resolveNearestProgress(index);

            if (index === state.activeIndex) {
                return;
            }

            if (state.snapTween) {
                state.snapTween.kill();
            }

            state.snapTween = gsap.to(state, {
                progress: destination,
                duration: 0.7,
                ease: 'power3.inOut',
                overwrite: true,
                onUpdate: render
            });
        };

        item.addEventListener('click', handleClick);
        cleanups.push(() => item.removeEventListener('click', handleClick));
    });

    const mouseMoveHandler = (event) => handlePointerMove(event);
    const mouseLeaveHandler = () => resetActiveTilt();
    stage.addEventListener('mousemove', mouseMoveHandler);
    stage.addEventListener('mouseleave', mouseLeaveHandler);
    cleanups.push(() => stage.removeEventListener('mousemove', mouseMoveHandler));
    cleanups.push(() => stage.removeEventListener('mouseleave', mouseLeaveHandler));

    if (typeof Observer !== 'undefined') {
        const observer = Observer.create({
            target: stage,
            type: 'wheel',
            preventDefault: true,
            onChangeX: (self) => {
                if (state.isMobile) {
                    nudgeProgress(self.deltaX * 0.0028 || self.deltaY * 0.0028);
                }
            },
            onChangeY: (self) => {
                nudgeProgress(self.deltaY * 0.0028);
            }
        });

        cleanups.push(() => observer.kill());
    }

    if (typeof Draggable !== 'undefined') {
        const draggers = Draggable.create(proxy, {
            trigger: stage,
            type: state.isMobile ? 'x' : 'y',
            inertia: typeof InertiaPlugin !== 'undefined',
            allowContextMenu: true,
            onPress() {
                dragStartProgress = state.progress;
                gsap.set(proxy, { x: 0, y: 0 });
                if (state.wheelTween) {
                    state.wheelTween.kill();
                }
                if (state.snapTween) {
                    state.snapTween.kill();
                }
            },
            onDrag() {
                const deltaPx = state.isMobile ? this.x : this.y;
                state.progress = wrapProgress(dragStartProgress - deltaPx / state.itemGap);
                render();
            },
            onThrowUpdate() {
                const deltaPx = state.isMobile ? this.x : this.y;
                state.progress = wrapProgress(dragStartProgress - deltaPx / state.itemGap);
                render();
            },
            onRelease() {
                if (!this.isThrowing) {
                    snapToNearest();
                }
            },
            onThrowComplete: snapToNearest
        });

        cleanups.push(() => {
            draggers.forEach((dragger) => dragger.kill());
        });
    }

    gsap.ticker.add(handleTick);
    cleanups.push(() => gsap.ticker.remove(handleTick));

    window.addEventListener('resize', handleResize);
    cleanups.push(() => window.removeEventListener('resize', handleResize));

    root._projectsCleanup = () => {
        cleanups.forEach((cleanup) => cleanup());
        resetActiveTilt();
        root.style.removeProperty('--projects-blur');
        delete root._projectsCleanup;
    };
}
// end: initProjectsShowcase

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProjectsShowcase);
} else {
    initProjectsShowcase();
}

// start: Coordina la versión sticky y móvil del bloque de servicios, activando visuales y transiciones según scroll.
function initServiciosReveal() {
    const sections = document.querySelectorAll('[data-servicios]');

    if (!sections.length) {
        return;
    }

    sections.forEach((section) => {
        if (section.dataset.serviciosReady === 'true') {
            return;
        }

        const sticky = section.querySelector('[data-servicios-sticky]');
        const stickyInset = section.querySelector('[data-servicios-sticky-inset]');
        const stickyMedia = section.querySelector('[data-servicios-sticky-media]');
        const stickyVisuals = Array.from(section.querySelectorAll('[data-servicios-sticky-visual]'));
        const groups = Array.from(section.querySelectorAll('[data-servicios-group]'));

        if (!groups.length) {
            return;
        }

        section.dataset.serviciosReady = 'true';
        let activeStickyVisual = null;

        const setStickyVisual = (visualKey, immediate) => {
            if (!stickyVisuals.length) {
                return;
            }

            const nextVisual = stickyVisuals.find((visual) => visual.dataset.serviciosStickyVisual === visualKey) || stickyVisuals[0];

            if (!nextVisual) {
                return;
            }

            if (nextVisual === activeStickyVisual) {
                stickyVisuals.forEach((visual) => {
                    visual.classList.toggle('is-active', visual === nextVisual);
                    visual.classList.toggle('is-prev', false);
                });
                return;
            }

            const previousVisual = activeStickyVisual;
            activeStickyVisual = nextVisual;

            stickyVisuals.forEach((visual) => {
                visual.classList.toggle('is-active', visual === nextVisual);
                visual.classList.toggle('is-prev', visual === previousVisual);
            });

            if (typeof gsap === 'undefined' || immediate) {
                stickyVisuals.forEach((visual) => {
                    visual.style.opacity = visual === nextVisual ? '1' : '0';
                    visual.style.transform = visual === nextVisual ? 'scale(1)' : 'scale(1.04)';
                });
                return;
            }

            if (previousVisual) {
                gsap.to(previousVisual, {
                    autoAlpha: 0,
                    scale: 0.96,
                    duration: 0.32,
                    ease: 'power2.out',
                    overwrite: true,
                    onComplete: () => previousVisual.classList.remove('is-prev')
                });
            }

            gsap.fromTo(nextVisual, {
                autoAlpha: 0,
                scale: 1.04
            }, {
                autoAlpha: 1,
                scale: 1,
                duration: 0.48,
                ease: 'power2.out',
                overwrite: true
            });
        };

        const setActive = (index, immediate = false) => {
            groups.forEach((group, groupIndex) => {
                group.classList.toggle('is-active', groupIndex === index);
            });

            const activeGroup = groups[index];
            if (activeGroup) {
                setStickyVisual(activeGroup.dataset.serviciosVisual, immediate);
            }
        };

        if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined' || !gsap.matchMedia) {
            setActive(0, true);
            return;
        }

        const mm = gsap.matchMedia();

        mm.add('(min-width: 1101px)', () => {
            setActive(0, true);

            const cleanups = [];

            if (stickyInset) {
                gsap.set(stickyInset, { y: '0vh' });
            }

            if (stickyMedia) {
                gsap.set(stickyMedia, {
                    scale: 1,
                    clipPath: 'inset(0vw 10vw)'
                });
            }

            if (sticky && stickyMedia) {
                const stickyTrigger = ScrollTrigger.create({
                    trigger: sticky,
                    scrub: true,
                    start: `top ${window.innerHeight - 120}px`,
                    end: 'bottom bottom',
                    onUpdate: (self) => {
                        gsap.set(stickyMedia, {
                            scale: 1 - 0.5 * self.progress,
                            clipPath: `inset(0vw ${10 - 10 * self.progress}vw)`,
                            ease: 'none'
                        });
                    }
                });

                cleanups.push(() => {
                    stickyTrigger.kill();
                    gsap.set(stickyMedia, { clearProps: 'transform,clipPath' });
                });
            }

            groups.forEach((group, index) => {
                const media = group.querySelector('.c-servicios_media');
                const activeTrigger = ScrollTrigger.create({
                    trigger: group,
                    start: 'top center',
                    end: 'bottom center',
                    onEnter: () => setActive(index),
                    onEnterBack: () => setActive(index)
                });

                cleanups.push(() => activeTrigger.kill());

                if (media) {
                    gsap.set(media, { y: '-100vh' });

                    const mediaTrigger = ScrollTrigger.create({
                        trigger: group,
                        scrub: true,
                        start: 'top bottom',
                        end: index === groups.length - 1 ? 'bottom bottom' : 'bottom top',
                        onUpdate: (self) => {
                            const yValue = index === groups.length - 1
                                ? 100 * self.progress - 100
                                : 200 * self.progress - 100;

                            gsap.set(media, {
                                y: `${yValue}vh`,
                                ease: 'none'
                            });
                        }
                    });

                    cleanups.push(() => {
                        mediaTrigger.kill();
                        gsap.set(media, { clearProps: 'transform' });
                    });
                }

                if (index === 0 && stickyInset) {
                    const insetTrigger = ScrollTrigger.create({
                        trigger: group,
                        scrub: true,
                        start: 'top bottom',
                        end: 'top top',
                        onUpdate: (self) => {
                            gsap.set(stickyInset, {
                                y: `${100 * self.progress}vh`,
                                ease: 'none'
                            });
                        }
                    });

                    cleanups.push(() => {
                        insetTrigger.kill();
                        gsap.set(stickyInset, { clearProps: 'transform' });
                    });
                }
            });

            return () => {
                cleanups.forEach((cleanup) => cleanup());
                stickyVisuals.forEach((visual) => {
                    visual.classList.remove('is-active', 'is-prev');
                    visual.style.removeProperty('opacity');
                    visual.style.removeProperty('transform');
                });
                activeStickyVisual = null;
                setActive(0, true);
            };
        });

        mm.add('(max-width: 1100px)', () => {
            setActive(0, true);
        });

        section._serviciosCleanup = () => {
            mm.revert();
            delete section._serviciosCleanup;
            delete section.dataset.serviciosReady;
        };
    });
}
// end: initServiciosReveal

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initServiciosReveal);
} else {
    initServiciosReveal();
}

// start counter
// start: Formatea un contador GSAP rellenando con ceros a la izquierda hasta la longitud indicada.
function formatGsapCounterValue(value, length) {
    return String(value).padStart(length, '0');
}
// end: formatGsapCounterValue

// start: Inicializa los contadores numéricos y lanza su animación una sola vez cuando entran en viewport.
function initGsapCounter() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        return;
    }

    const counters = document.querySelectorAll('.c-counter_value[data-counter-target]');

    if (!counters.length) {
        return;
    }

    counters.forEach((counter) => {
        if (counter.dataset.counterReady === 'true') {
            return;
        }

        const rawTarget = String(counter.dataset.counterTarget || counter.textContent).trim();
        const target = Number.parseInt(rawTarget.replace(/[^\d-]/g, ''), 10);

        if (Number.isNaN(target)) {
            return;
        }

        const digitsLength = Math.max(rawTarget.length, String(Math.max(target, 0)).length);
        const state = { value: 0 };

        counter.dataset.counterReady = 'true';
        counter.textContent = formatGsapCounterValue(0, digitsLength);

        const tween = gsap.to(state, {
            value: Math.max(target, 0),
            duration: 1.2,
            ease: 'power2.out',
            paused: true,
            onUpdate: () => {
                counter.textContent = formatGsapCounterValue(Math.round(state.value), digitsLength);
            }
        });

        ScrollTrigger.create({
            trigger: counter.closest('.c-counter_item') || counter,
            start: 'top 85%',
            once: true,
            onEnter: () => tween.play()
        });
    });
}
// end: initGsapCounter

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGsapCounter);
} else {
    initGsapCounter();
}
// end counter


// start: Carga las sources diferidas de un video del swiper de dispositivos solo cuando hacen falta.
function loadSwiperDispositivosVideo(video) {
    if (!video || video.dataset.swiperDispositivosLoaded === 'true') {
        return;
    }

    const sources = video.querySelectorAll('source[data-src]');

    if (!sources.length) {
        video.dataset.swiperDispositivosLoaded = 'true';
        return;
    }

    sources.forEach(source => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
    });

    video.load();
    video.dataset.swiperDispositivosLoaded = 'true';
}
// end: loadSwiperDispositivosVideo

// start: Pausa o reproduce los videos del swiper de dispositivos según su visibilidad real.
function setupSwiperDispositivosVideos(element) {
    const videos = element.querySelectorAll('.js-swiper-dispositivos-video');

    if (!videos.length) {
        return;
    }

    const playVisibleVideo = (video) => {
        loadSwiperDispositivosVideo(video);

        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
        }
    };

    const pauseHiddenVideo = (video) => {
        video.pause();
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const video = entry.target;

            if (entry.isIntersecting && entry.intersectionRatio >= 0.6 && document.visibilityState === 'visible') {
                playVisibleVideo(video);
                return;
            }

            pauseHiddenVideo(video);
        });
    }, {
        root: element,
        threshold: [0, 0.6, 1]
    });

    videos.forEach(video => {
        observer.observe(video);
    });

    document.addEventListener('visibilitychange', () => {
        videos.forEach(video => {
            if (document.visibilityState !== 'visible') {
                pauseHiddenVideo(video);
                return;
            }

            const rect = video.getBoundingClientRect();
            const rootRect = element.getBoundingClientRect();
            const isVisibleInsideSwiper =
                rect.right > rootRect.left &&
                rect.left < rootRect.right &&
                rect.bottom > rootRect.top &&
                rect.top < rootRect.bottom;

            if (isVisibleInsideSwiper) {
                playVisibleVideo(video);
            }
        });
    });
}
// end: setupSwiperDispositivosVideos

// start: Reproduce y pausa los videos fullscreen cuando entran o salen del viewport.
function setupVideoFullVideos() {
    const videos = document.querySelectorAll('.js-video-full-video');

    if (!videos.length) {
        return;
    }

    const playVisibleVideo = (video) => {
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
        }
    };

    const pauseHiddenVideo = (video) => {
        video.pause();
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const video = entry.target;

            if (entry.isIntersecting && entry.intersectionRatio >= 0.10 && document.visibilityState === 'visible') {
                playVisibleVideo(video);
                return;
            }

            pauseHiddenVideo(video);
        });
    }, {
        threshold: [0, 0.10, 1]
    });

    videos.forEach(video => {
        observer.observe(video);
    });

    document.addEventListener('visibilitychange', () => {
        videos.forEach(video => {
            if (document.visibilityState !== 'visible') {
                pauseHiddenVideo(video);
                return;
            }

            const rect = video.getBoundingClientRect();
            const isVisible =
                rect.right > 0 &&
                rect.left < window.innerWidth &&
                rect.bottom > 0 &&
                rect.top < window.innerHeight;

            if (isVisible) {
                playVisibleVideo(video);
            }
        });
    });
}
// end: setupVideoFullVideos

// start: swiperDispositivos
function swiperDispositivos(elements) {
    elements.forEach(element => {
        if (element.swiper || typeof Swiper === 'undefined') {
            return;
        }

        new Swiper(element, {
            slidesPerView: "auto",
            mousewheel: true,
            // spaceBetween: "24",
            freeMode: {
                enabled: true
            },
            breakpoints: {
                0: {
                    spaceBetween: "16"
                },
                992: {
                    spaceBetween: "24"
                }
            },
            pagination: {
                el: element.querySelector(".swiper-pagination"),
                clickable: true
            }
        });

        setupSwiperDispositivosVideos(element);
    });
}
// end: swiperDispositivos
